import * as A from "react";
import { z as ie } from "./index-c07310bf.js";
import { Z as xr } from "./index-efd35e77.js";
var ue = {
  en: {
    name: "en",
    identity: {
      version: {
        _unicodeVersion: "14.0.0",
        _cldrVersion: "41"
      },
      language: "en"
    },
    territory: "US",
    numbers: {
      symbols: {
        decimal: ".",
        group: ",",
        list: ";",
        percentSign: "%",
        plusSign: "+",
        minusSign: "-",
        exponential: "E",
        superscriptingExponent: "×",
        perMille: "‰",
        infinity: "∞",
        nan: "NaN",
        timeSeparator: ":",
        approximatelySign: "~"
      },
      decimal: {
        patterns: [
          "n"
        ],
        groupSize: [
          3
        ]
      },
      scientific: {
        patterns: [
          "nEn"
        ],
        groupSize: []
      },
      percent: {
        patterns: [
          "n%"
        ],
        groupSize: [
          3
        ]
      },
      currency: {
        patterns: [
          "$n"
        ],
        groupSize: [
          3
        ],
        "unitPattern-count-one": "n $",
        "unitPattern-count-other": "n $"
      },
      currencies: {
        BGN: {
          displayName: "Bulgarian Lev",
          "displayName-count-one": "Bulgarian lev",
          "displayName-count-other": "Bulgarian leva",
          symbol: "BGN"
        },
        EUR: {
          displayName: "Euro",
          "displayName-count-one": "euro",
          "displayName-count-other": "euros",
          symbol: "€",
          "symbol-alt-narrow": "€"
        },
        USD: {
          displayName: "US Dollar",
          "displayName-count-one": "US dollar",
          "displayName-count-other": "US dollars",
          symbol: "$",
          "symbol-alt-narrow": "$"
        }
      },
      localeCurrency: "USD",
      accounting: {
        patterns: [
          "$n",
          "($n)"
        ],
        groupSize: [
          3
        ]
      }
    },
    calendar: {
      gmtFormat: "GMT{0}",
      gmtZeroFormat: "GMT",
      patterns: {
        d: "M/d/y",
        D: "EEEE, MMMM d, y",
        m: "MMM d",
        M: "MMMM d",
        y: "MMM y",
        Y: "MMMM y",
        F: "EEEE, MMMM d, y h:mm:ss a",
        g: "M/d/y h:mm a",
        G: "M/d/y h:mm:ss a",
        t: "h:mm a",
        T: "h:mm:ss a",
        s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
        u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'"
      },
      dateTimeFormats: {
        full: "{1} 'at' {0}",
        long: "{1} 'at' {0}",
        medium: "{1}, {0}",
        short: "{1}, {0}",
        availableFormats: {
          Bh: "h B",
          Bhm: "h:mm B",
          Bhms: "h:mm:ss B",
          d: "d",
          E: "ccc",
          EBhm: "E h:mm B",
          EBhms: "E h:mm:ss B",
          Ed: "d E",
          Ehm: "E h:mm a",
          EHm: "E HH:mm",
          Ehms: "E h:mm:ss a",
          EHms: "E HH:mm:ss",
          Gy: "y G",
          GyMd: "M/d/y GGGGG",
          GyMMM: "MMM y G",
          GyMMMd: "MMM d, y G",
          GyMMMEd: "E, MMM d, y G",
          h: "h a",
          H: "HH",
          hm: "h:mm a",
          Hm: "HH:mm",
          hms: "h:mm:ss a",
          Hms: "HH:mm:ss",
          hmsv: "h:mm:ss a v",
          Hmsv: "HH:mm:ss v",
          hmv: "h:mm a v",
          Hmv: "HH:mm v",
          M: "L",
          Md: "M/d",
          MEd: "E, M/d",
          MMM: "LLL",
          MMMd: "MMM d",
          MMMEd: "E, MMM d",
          MMMMd: "MMMM d",
          "MMMMW-count-one": "'week' W 'of' MMMM",
          "MMMMW-count-other": "'week' W 'of' MMMM",
          ms: "mm:ss",
          y: "y",
          yM: "M/y",
          yMd: "M/d/y",
          yMEd: "E, M/d/y",
          yMMM: "MMM y",
          yMMMd: "MMM d, y",
          yMMMEd: "E, MMM d, y",
          yMMMM: "MMMM y",
          yQQQ: "QQQ y",
          yQQQQ: "QQQQ y",
          "yw-count-one": "'week' w 'of' Y",
          "yw-count-other": "'week' w 'of' Y"
        }
      },
      timeFormats: {
        full: "h:mm:ss a zzzz",
        long: "h:mm:ss a z",
        medium: "h:mm:ss a",
        short: "h:mm a"
      },
      dateFormats: {
        full: "EEEE, MMMM d, y",
        long: "MMMM d, y",
        medium: "MMM d, y",
        short: "M/d/yy"
      },
      days: {
        format: {
          abbreviated: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
          ],
          narrow: [
            "S",
            "M",
            "T",
            "W",
            "T",
            "F",
            "S"
          ],
          short: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
          ],
          wide: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
          ]
        },
        "stand-alone": {
          abbreviated: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
          ],
          narrow: [
            "S",
            "M",
            "T",
            "W",
            "T",
            "F",
            "S"
          ],
          short: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
          ],
          wide: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
          ]
        }
      },
      months: {
        format: {
          abbreviated: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ],
          narrow: [
            "J",
            "F",
            "M",
            "A",
            "M",
            "J",
            "J",
            "A",
            "S",
            "O",
            "N",
            "D"
          ],
          wide: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
          ]
        },
        "stand-alone": {
          abbreviated: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ],
          narrow: [
            "J",
            "F",
            "M",
            "A",
            "M",
            "J",
            "J",
            "A",
            "S",
            "O",
            "N",
            "D"
          ],
          wide: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
          ]
        }
      },
      quarters: {
        format: {
          abbreviated: [
            "Q1",
            "Q2",
            "Q3",
            "Q4"
          ],
          narrow: [
            "1",
            "2",
            "3",
            "4"
          ],
          wide: [
            "1st quarter",
            "2nd quarter",
            "3rd quarter",
            "4th quarter"
          ]
        },
        "stand-alone": {
          abbreviated: [
            "Q1",
            "Q2",
            "Q3",
            "Q4"
          ],
          narrow: [
            "1",
            "2",
            "3",
            "4"
          ],
          wide: [
            "1st quarter",
            "2nd quarter",
            "3rd quarter",
            "4th quarter"
          ]
        }
      },
      dayPeriods: {
        format: {
          abbreviated: {
            midnight: "midnight",
            am: "AM",
            "am-alt-variant": "am",
            noon: "noon",
            pm: "PM",
            "pm-alt-variant": "pm",
            morning1: "in the morning",
            afternoon1: "in the afternoon",
            evening1: "in the evening",
            night1: "at night"
          },
          narrow: {
            midnight: "mi",
            am: "a",
            "am-alt-variant": "am",
            noon: "n",
            pm: "p",
            "pm-alt-variant": "pm",
            morning1: "in the morning",
            afternoon1: "in the afternoon",
            evening1: "in the evening",
            night1: "at night"
          },
          wide: {
            midnight: "midnight",
            am: "AM",
            "am-alt-variant": "am",
            noon: "noon",
            pm: "PM",
            "pm-alt-variant": "pm",
            morning1: "in the morning",
            afternoon1: "in the afternoon",
            evening1: "in the evening",
            night1: "at night"
          }
        },
        "stand-alone": {
          abbreviated: {
            midnight: "midnight",
            am: "AM",
            "am-alt-variant": "am",
            noon: "noon",
            pm: "PM",
            "pm-alt-variant": "pm",
            morning1: "morning",
            afternoon1: "afternoon",
            evening1: "evening",
            night1: "night"
          },
          narrow: {
            midnight: "midnight",
            am: "AM",
            "am-alt-variant": "am",
            noon: "noon",
            pm: "PM",
            "pm-alt-variant": "pm",
            morning1: "morning",
            afternoon1: "afternoon",
            evening1: "evening",
            night1: "night"
          },
          wide: {
            midnight: "midnight",
            am: "AM",
            "am-alt-variant": "am",
            noon: "noon",
            pm: "PM",
            "pm-alt-variant": "pm",
            morning1: "morning",
            afternoon1: "afternoon",
            evening1: "evening",
            night1: "night"
          }
        }
      },
      eras: {
        format: {
          wide: {
            0: "Before Christ",
            1: "Anno Domini",
            "0-alt-variant": "Before Common Era",
            "1-alt-variant": "Common Era"
          },
          abbreviated: {
            0: "BC",
            1: "AD",
            "0-alt-variant": "BCE",
            "1-alt-variant": "CE"
          },
          narrow: {
            0: "B",
            1: "A",
            "0-alt-variant": "BCE",
            "1-alt-variant": "CE"
          }
        }
      },
      dateFields: {
        era: {
          wide: "era",
          short: "era",
          narrow: "era"
        },
        year: {
          wide: "year",
          short: "yr.",
          narrow: "yr."
        },
        quarter: {
          wide: "quarter",
          short: "qtr.",
          narrow: "qtr."
        },
        month: {
          wide: "month",
          short: "mo.",
          narrow: "mo."
        },
        week: {
          wide: "week",
          short: "wk.",
          narrow: "wk."
        },
        weekOfMonth: {
          wide: "week of month",
          short: "wk. of mo.",
          narrow: "wk. of mo."
        },
        day: {
          wide: "day",
          short: "day",
          narrow: "day"
        },
        dayOfYear: {
          wide: "day of year",
          short: "day of yr.",
          narrow: "day of yr."
        },
        weekday: {
          wide: "day of the week",
          short: "day of wk.",
          narrow: "day of wk."
        },
        weekdayOfMonth: {
          wide: "weekday of the month",
          short: "wkday. of mo.",
          narrow: "wkday. of mo."
        },
        dayperiod: {
          short: "AM/PM",
          wide: "AM/PM",
          narrow: "AM/PM"
        },
        hour: {
          wide: "hour",
          short: "hr.",
          narrow: "hr."
        },
        minute: {
          wide: "minute",
          short: "min.",
          narrow: "min."
        },
        second: {
          wide: "second",
          short: "sec.",
          narrow: "sec."
        },
        zone: {
          wide: "time zone",
          short: "zone",
          narrow: "zone"
        },
        millisecond: {
          narrow: "ms",
          short: "ms",
          wide: "millisecond"
        }
      }
    }
  },
  supplemental: {
    likelySubtags: {
      en: "en-Latn-US"
    },
    currencyData: {
      region: {
        US: [
          {
            USD: {
              _from: "1792-01-01"
            }
          }
        ]
      }
    },
    weekData: {
      firstDay: {
        US: "sun"
      },
      weekendStart: {
        "001": "sat"
      },
      weekendEnd: {
        "001": "sun"
      }
    }
  }
};
function q(r) {
  return typeof r == "string";
}
const oe = {
  NoLocale: "Missing locale info for '{0}'",
  NoCurrency: "Cannot determine currency information. Please load the locale currencies data.",
  NoSupplementalCurrency: "Cannot determine currency. Please load the supplemental currencyData.",
  NoCurrencyRegion: "No currency data for region '{0}'",
  NoCurrencyDisplay: "Cannot determine currency display information. Please load the locale currencies data. The default culture does not include the all currencies data.",
  NoGMTInfo: "Cannot determine locale GMT format. Please load the locale timeZoneNames data.",
  NoWeekData: "Cannot determine locale first day of week. Please load the supplemental weekData.",
  NoFirstDay: "Cannot determine locale first day of week. Please load the supplemental weekData. The default culture includes only the 'en-US' first day info.",
  NoValidCurrency: "Cannot determine a default currency for the {0} locale. Please specify explicitly the currency with the format options.",
  NoDateFieldNames: "Cannot determine the locale date field names. Please load the locale dateFields data."
};
var se = /\{(\d+)}?\}/g, sr = function(e) {
  var n = e.name, a = e.message;
  if (!n || !a)
    throw new Error("{ name: string, message: string } object is required!");
  this.name = n, this.message = a;
};
sr.prototype.formatMessage = function() {
  for (var e = [], n = arguments.length; n--; )
    e[n] = arguments[n];
  var a = le(e), t = this.message.replace(se, function(i, u) {
    return a[parseInt(u, 10)];
  });
  return this.name + ": " + t;
};
sr.prototype.error = function() {
  for (var e = [], n = arguments.length; n--; )
    e[n] = arguments[n];
  return new Error(this.formatMessage(e));
};
var le = function(r) {
  return r.reduce(function(e, n) {
    return e.concat(n);
  }, []);
}, ve = function(r) {
  var e = function(n, a) {
    return n[a] = new sr({ name: a, message: r[a] }), n;
  };
  return Object.keys(r).reduce(e, {});
}, T = ve(oe);
function ce(r, e) {
  var n = r.split("-"), a = n[0], t = n[1], i = n[2];
  return N[r] || e.indexOf(i) !== -1 && N[a + "-" + i] || e.indexOf(t) !== -1 && N[a + "-" + t] || N[a];
}
function me(r, e) {
  for (var n = N.supplemental.likelySubtags, a = 0; a < e.length; a++) {
    var t = n[r + "-" + e[a]];
    if (t)
      return t;
  }
  if (n[r])
    return n[r];
}
var N = ue;
function B(r) {
  var e;
  return q(r) ? e = R(r) : e = r, e;
}
function R(r) {
  if (N[r])
    return N[r];
  var e = N.supplemental.likelySubtags;
  if (e) {
    var n = r.split("-"), a = n[0], t = n.slice(1), i = me(a, t), u = i ? ce(i, t) : null;
    if (u)
      return u;
  }
  throw T.NoLocale.error(r);
}
var Or = "decimal", J = "currency", _r = "accounting", P = "percent", Pr = "scientific", V = "$", lr = "%", _ = "n", fe = ";", de = ",", I = ".", m = "", k = "en";
function ye(r, e) {
  var n = N.supplemental.likelySubtags, a = r.split("-");
  if (n) {
    var t = n[r] || n[a[0]];
    t && (a = t.split("-"));
  }
  if (e)
    for (var i = a.length - 1; i >= 1; i--) {
      var u = a[i];
      (u === e.variant || u === e.script) && a.splice(i, 1);
    }
  var s = a.length;
  if (s > 1) {
    var o = a[s - 1];
    return o.toUpperCase();
  }
}
function kr(r) {
  if (r.territory)
    return r.territory;
  var e = r.name, n = r.identity, a;
  return n && n.territory ? a = n.territory : a = ye(e, n), r.territory = a, a;
}
function ge(r, e) {
  e === void 0 && (e = k);
  var n = R(e), a = n.calendar.dateFields;
  if (!a)
    throw T.NoDateFieldNames.error();
  var t = a[r.type] || {};
  return t[r.nameType] || t.wide;
}
function he(r) {
  for (var e = [], n = 0; n < r.length; n++)
    e.push(r[n].toLowerCase());
  return e;
}
function pe(r) {
  var e = {};
  for (var n in r)
    e[n] = r[n].toLowerCase();
  return e;
}
function Me(r) {
  var e = Array.isArray(r) ? he(r) : pe(r);
  return e;
}
function Gr(r, e) {
  var n = e.type, a = e.nameType, t = e.standAlone, i = e.lower, u = B(r), s = t ? "stand-alone" : "format", o = (i ? "lower-" : m) + a, l = u.calendar[n][s], c = l[o];
  return !c && i && (c = l[o] = Me(l[a])), c;
}
function j(r) {
  var e = r.split("-"), n = parseInt(e[0], 10), a = parseInt(e[1], 10) - 1, t = parseInt(e[2], 10);
  return new Date(n, a, t);
}
var Ee = T.NoCurrency, Se = T.NoCurrencyDisplay, De = T.NoSupplementalCurrency, Ne = T.NoCurrencyRegion, we = T.NoValidCurrency, pr = 2, rr = "symbol", be = "XXX", Mr = {
  "001": "USD",
  // 001 refers to world. not sure if it is correct to assume USD but seems better than throw an error
  150: "EUR"
  // 150 territory for Europe
};
function Ur(r, e, n) {
  var a = B(r), t = a.numbers.currencies;
  if (!t) {
    if (n)
      throw Ee.error();
    return;
  }
  var i = t[e];
  if (!i) {
    if (n)
      throw Se.error();
    return;
  }
  return i;
}
function Te(r, e) {
  return e.length - r.length;
}
function Fe(r) {
  for (var e, n, a, t, i = 0; i < r.length; i++) {
    var u = r[i], s = Object.keys(u)[0], o = u[s];
    if (s !== be && o._tender !== "false" && o._from)
      if (o._to) {
        if (!a) {
          var c = j(o._from), v = j(o._to);
          (!n || n.to < v || n.from < c) && (e = s, n = {
            from: c,
            to: v
          });
        }
      } else {
        var l = j(o._from);
        (!t || t < l) && (a = s, t = l);
      }
  }
  return a || e;
}
function Ce(r, e, n) {
  n === void 0 && (n = !0);
  var a = Ur(r, e, n);
  if (a) {
    if (!a.displays) {
      var t = [e];
      for (var i in a)
        t.push(a[i]);
      t.sort(Te), a.displays = t;
    }
    return a.displays;
  }
}
function Ae(r, e) {
  var n = e.value, a = e.currency, t = e.currencyDisplay;
  if (t === void 0 && (t = rr), t === "code")
    return a;
  var i = Ur(r, a, !0), u;
  return t === rr ? u = i["symbol-alt-narrow"] || i[rr] : typeof n > "u" || n !== 1 ? u = i["displayName-count-other"] : u = i["displayName-count-one"], u;
}
function He(r) {
  var e = pr, n = pr, a = ((N.supplemental.currencyData || {}).fractions || {})[r];
  return a && a._digits && (n = e = parseInt(a._digits, 10)), {
    minimumFractionDigits: e,
    maximumFractionDigits: n
  };
}
function Ie(r, e) {
  if (e === void 0 && (e = !0), Mr[r])
    return Mr[r];
  var n = N.supplemental.currencyData;
  if (!n) {
    if (e)
      throw De.error();
    return;
  }
  var a = n.region[r];
  if (!a) {
    if (e)
      throw Ne.error(r);
    return;
  }
  var t = Fe(a);
  return t;
}
function vr(r, e) {
  var n = B(r), a = n.numbers;
  if (!a.localeCurrency) {
    var t = Ie(kr(n), e);
    if (!t && e)
      throw we.error(n.name);
    a.localeCurrency = t;
  }
  return a.localeCurrency;
}
var Le = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"], Re = "001", xe = T.NoWeekData, Oe = T.NoFirstDay;
function zr(r) {
  var e = B(r);
  if (!isNaN(e.firstDay))
    return e.firstDay;
  var n = N.supplemental.weekData;
  if (!n)
    throw xe.error();
  var a = n.firstDay[kr(e)] || n.firstDay[Re];
  if (!a)
    throw Oe.error();
  return e.firstDay = Le.indexOf(a), e.firstDay;
}
T.NoWeekData;
function _e(r) {
  var e = B(r);
  return e.numbers.symbols;
}
function Zr(r) {
  return 1 / r === -1 / 0;
}
function Br(r, e) {
  e === void 0 && (e = {}), e.currency || (e.currency = vr(r, !0));
  var n = Ae(r, e);
  return n;
}
function Qr(r, e, n, a, t) {
  var i = t.numbers.symbols, u = r.indexOf(i.decimal), s = a.groupSize.slice(), o = s.shift(), l = u !== -1 ? u : n + 1, c = r.substring(e, l), v = r, d = c.length;
  if (d >= o) {
    for (var f = d, p = []; f > -1; ) {
      var y = c.substring(f - o, f);
      y && p.push(y), f -= o;
      var D = s.shift();
      if (o = D !== void 0 ? D : o, o === 0) {
        y = c.substring(0, f), y && p.push(y);
        break;
      }
    }
    c = p.reverse().join(i.group), v = r.substring(0, e) + c + r.substring(l);
  }
  return v;
}
function cr(r) {
  return r === J || r === _r;
}
function S(r, e, n) {
  e === void 0 && (e = 2), n === void 0 && (n = !1);
  var a = e - String(r).length, t = r;
  if (a > 0) {
    var i = new Array(a + 1).join("0");
    t = n ? r + i : i + r;
  }
  return t;
}
var Pe = 20;
function U(r, e) {
  var n = r, a = e || 0;
  return n = n.toString().split("e"), n = Math.round(+(n[0] + "e" + (n[1] ? Number(n[1]) + a : a))), n = n.toString().split("e"), n = +(n[0] + "e" + (n[1] ? Number(n[1]) - a : -a)), n.toFixed(Math.min(a, Pe));
}
var ke = 3, Ge = 0, Ue = /0+$/;
function ze(r) {
  var e = r.minimumFractionDigits, n = r.maximumFractionDigits, a = r.style, t = cr(a), i;
  return t && (i = He(r.currency)), e === void 0 && (e = t ? i.minimumFractionDigits : 0), n === void 0 && (a === P ? n = Math.max(e, Ge) : t ? n = Math.max(e, i.maximumFractionDigits) : n = Math.max(e, ke)), {
    minimumFractionDigits: e,
    maximumFractionDigits: n
  };
}
function Ze(r, e, n) {
  for (var a = m, t = 0, i = e.length; t < i; t++) {
    var u = e.charAt(t);
    u === _ ? a += r : u === V || u === lr ? a += n : a += u;
  }
  return a;
}
function Be(r, e) {
  var n = r.numbers.currency, a = e !== 1 ? n["unitPattern-count-other"] : n["unitPattern-count-one"];
  return e < 0 && (a = a.replace(_, "-" + _)), a;
}
function Qe(r, e, n) {
  var a = n.numbers.symbols, t = e.style, i = cr(t);
  if (t === Pr) {
    var u = e.minimumFractionDigits !== void 0 ? r.toExponential(e.minimumFractionDigits) : r.toExponential();
    return u.replace(I, a.decimal);
  }
  var s = r, o;
  i && (e.value = s, o = Br(n, e)), t === P && (s *= 100, o = a.percentSign);
  var l = ze(e), c = l.minimumFractionDigits, v = l.maximumFractionDigits;
  s = U(s, v);
  var d = s < 0, f = Zr(r), p = s.split(I), y = p[0], D = S(p[1] ? p[1].replace(Ue, m) : m, c, !0);
  d && (y = y.substring(1)), e.minimumIntegerDigits && (y = S(y, e.minimumIntegerDigits));
  var b = e.useGrouping !== !1 ? Qr(y, 0, y.length, e, n) : y;
  D && (b += a.decimal + D);
  var E;
  if (i && e.currencyDisplay === "name")
    E = Be(n, r);
  else {
    var H = e.patterns;
    E = d || f ? H[1] || "-" + H[0] : H[0];
  }
  if (E === _ && !d)
    return b;
  var te = Ze(b, E, o);
  return te;
}
var Xe = /(\\.)|(['][^']*[']?)|(["][^"]*["]?)/g, Xr = "__??__";
function Yr(r, e) {
  var n = r.format;
  n.indexOf(lr) !== -1 && (r.style = P, r.symbol = e.numbers.symbols.percentSign, r.number *= 100), n.indexOf(V) !== -1 && (r.style = J, r.symbol = Br(e));
}
function Wr(r) {
  var e = r.format;
  if (e.indexOf("'") > -1 || e.indexOf('"') > -1 || e.indexOf("\\") > -1) {
    var n = r.literals = [];
    r.format = e.replace(Xe, function(a) {
      var t = a.charAt(0).replace("\\", m), i = a.slice(1).replace(t, m);
      return n.push(i), Xr;
    });
  }
}
function Ye(r, e) {
  var n = r;
  if (e)
    for (var a = e.length, t = 0; t < a; t++)
      n = n.replace(Xr, e[t]);
  return n;
}
var z = "#", Z = "0", We = /(\.(?:[0-9]*[1-9])?)0+$/g, qe = /\.$/, Je = /,/g;
function Ve(r, e) {
  var n;
  return e === 0 ? n = We : n = new RegExp("(\\.[0-9]{" + e + "}[1-9]*)0+$", "g"), r.replace(n, "$1").replace(qe, m);
}
function $e(r) {
  var e = r.number, n = r.format, a = n.indexOf(I);
  if (a !== -1) {
    var t = n.lastIndexOf(Z) - a, i = n.lastIndexOf(z) - a, u = t > -1, s = i > -1, o = e.toString().split("e");
    o[1] ? o = U(e, Math.abs(o[1])) : o = o[0], o = o.split(I)[1] || m;
    var l = o.length, c = -1;
    !u && !s ? (r.format = n.substring(0, a) + n.substring(a + 1), a = -1, l = 0) : u && t > i ? l = t : i > t && (s && l > i ? l = i : u && l < t && (l = t), c = u ? t : 0), l > -1 && (e = U(e, l), c > -1 && (e = Ve(e, c)));
  } else
    e = U(e);
  r.negative && e * -1 >= 0 && !r.negativeZero && (r.negative = !1), r.number = e, r.decimalIndex = a;
}
function Ke(r) {
  return r.indexOf(z) === -1 && r.indexOf(Z) === -1;
}
function je(r) {
  var e = r.number, n = r.format;
  if (n = n.split(fe), (r.negative || r.negativeZero) && n[1])
    n = n[1], r.hasNegativeFormat = !0;
  else if (e === 0) {
    var a = n[2];
    n = a || n[0], a && Ke(a) && (r.constant = a);
  } else
    n = n[0];
  r.format = n;
}
function rn(r) {
  r.hasGroup = r.format.indexOf(de) > -1, r.hasGroup && (r.format = r.format.replace(Je, m));
}
function Er(r, e, n) {
  var a;
  return r === -1 && e !== -1 ? a = e : r !== -1 && e === -1 ? a = r : a = n ? Math.min(r, e) : Math.max(r, e), a;
}
function en(r) {
  var e = r.format, n = e.indexOf(z), a = e.indexOf(Z), t = Er(n, a, !0);
  n = e.lastIndexOf(z), a = e.lastIndexOf(Z);
  var i = Er(n, a);
  t === e.length && (i = t), r.start = t, r.end = i, r.lastZeroIndex = a;
}
function nn(r, e, n) {
  var a = r;
  if (e === J || e === P) {
    a = m;
    for (var t = 0, i = r.length; t < i; t++) {
      var u = r.charAt(t);
      a += u === V || u === lr ? n : u;
    }
  }
  return a;
}
function an(r, e) {
  var n = r.start, a = r.end, t = r.negative, i = r.negativeZero, u = r.format, s = r.decimalIndex, o = r.lastZeroIndex, l = r.hasNegativeFormat, c = r.hasGroup, v = r.number, d = v.toString().split(I), f = u.length, p = d[0], y = d[1] || m, D = p.length, b = m;
  v = u.substring(0, n), (t || i) && !l && (v += "-");
  for (var E = n; E < f; E++) {
    var H = u.charAt(E);
    if (s === -1) {
      if (a - E < D) {
        v += p;
        break;
      }
    } else if (o !== -1 && o < E && (b = m), s - E <= D && s - E > -1 && (v += p, E = s), s === E) {
      v += (y ? e.numbers.symbols.decimal : m) + y, E += a - s + 1;
      continue;
    }
    H === Z ? (v += H, b = H) : H === z && (v += b);
  }
  return c && (v = Qr(v, n + (t && !l ? 1 : 0), Math.max(a, D + n), e.numbers.decimal, e)), a >= n && (v += u.substring(a + 1)), v;
}
function tn(r, e) {
  var n = r.number;
  return r.start !== -1 && (n = an(r, e), n = nn(n, r.style, r.symbol), n = Ye(n, r.literals)), n;
}
function un(r, e, n) {
  var a = {
    negative: r < 0,
    number: Math.abs(r),
    negativeZero: Zr(r),
    format: e
  };
  return je(a), a.constant ? a.constant : (Wr(a), Yr(a, n), rn(a), $e(a), en(a), tn(a, n));
}
var on = /^(n|c|p|e|a)(\d*)$/i;
function sn(r) {
  var e = on.exec(r);
  if (e) {
    var n = {
      style: Or
    }, a = e[1].toLowerCase();
    return a === "c" ? n.style = J : a === "a" ? n.style = _r : a === "p" ? n.style = P : a === "e" && (n.style = Pr), e[2] && (n.minimumFractionDigits = n.maximumFractionDigits = parseInt(e[2], 10)), n;
  }
}
function qr(r) {
  var e;
  return q(r) ? e = sn(r) : e = r, e;
}
function Jr(r, e, n) {
  if (e === void 0 && (e = _), n === void 0 && (n = k), r == null)
    return m;
  if (!isFinite(r))
    return String(r);
  var a = R(n), t = qr(e), i;
  if (t) {
    var u = t.style || Or;
    i = Qe(r, Object.assign({}, a.numbers[u], t), a);
  } else
    i = un(r, e, a);
  return i;
}
function mr(r) {
  return typeof r == "number";
}
var ln = /[eE][-+]?[0-9]+/, Sr = /\u00A0/g;
function Dr(r, e) {
  if (e.length > 1) {
    var n = (e[1] || m).replace(V, m).split(_);
    if (r.indexOf(n[0]) > -1 && r.indexOf(n[1]) > -1)
      return r.replace(n[0], m).replace(n[1], m);
  }
}
function vn(r, e, n) {
  var a = qr(n) || {}, t = cr(a.style), i = r, u, s = a.currency || vr(e, t);
  if (s) {
    var o = Ce(e, s, t);
    if (o)
      for (var l = 0; l < o.length; l++) {
        var c = o[l];
        if (i.includes(c)) {
          i = i.replace(c, m), t = !0;
          break;
        }
      }
    if (t) {
      var v = Dr(i, e.numbers.currency.patterns) || Dr(i, e.numbers.accounting.patterns);
      v && (u = !0, i = v);
    }
  }
  return {
    number: i,
    negative: u
  };
}
function cn(r, e) {
  var n = e.literals, a = r;
  if (n)
    for (var t = 0; t < n.length; t++)
      a = a.replace(n[t], m);
  return a;
}
function mn(r) {
  var e = String(r), n = e.indexOf(I), a = 2, t = r / Math.pow(10, a);
  if (n === -1 || String(t).length <= e.length + a)
    return t;
  var i = e.length - n + 1 + a;
  return parseFloat(t.toFixed(i));
}
function fn(r, e, n) {
  if (e === void 0 && (e = k), n === void 0 && (n = {}), !r && r !== 0)
    return null;
  if (mr(r))
    return r;
  var a = R(e), t = a.numbers.symbols, i = r.toString(), u = n || {}, s;
  if (q(n) && (u = { format: n }, Wr(u), i = cn(i, u), Yr(u, a)), (u.style === P || i.indexOf(t.percentSign) > -1) && (i = i.replace(t.percentSign, m), s = !0), ln.test(i))
    return i = parseFloat(i.replace(t.decimal, I)), isNaN(i) ? null : i;
  var o = vn(i, a, u), l = o.negative, c = o.number;
  i = String(c).trim();
  var v = i.indexOf("-");
  if (v > 0)
    return null;
  var d = v > -1;
  return d = l !== void 0 ? l : d, i = i.replace("-", m).replace(Sr, " ").split(t.group.replace(Sr, " ")).join(m).replace(t.decimal, I), i = parseFloat(i), isNaN(i) ? i = null : d && (i *= -1), i && s && (i = mn(i)), i;
}
var dn = /\{(\d+)}/g;
function fr(r) {
  var e = arguments;
  return r.replace(dn, function(n, a) {
    var t = e[parseInt(a, 10) + 1];
    return t;
  });
}
var yn = 120, gn = 20, Nr = [2, 1, 5, 3, 4], hn = -2, pn = -1, Mn = 1, En = 2, Q = {};
Q[hn.toString()] = 8;
Q[pn.toString()] = 6;
Q[En.toString()] = 6;
Q[Mn.toString()] = 3;
var Sn = {
  numeric: 1,
  "2-digit": 2,
  short: 3,
  long: 4,
  narrow: 5
}, Dn = /[hHmsSzZoOvVxX]/;
function Nn(r) {
  return r.hour12 ? "h" : "H";
}
var wr = [{
  key: "era",
  specifier: "G"
}, {
  key: "year",
  specifier: "y"
}, {
  key: "month",
  specifier: "M"
}, {
  key: "day",
  specifier: "d"
}, {
  key: "weekday",
  specifier: "E"
}, {
  key: "hour",
  getSpecifier: Nn
}, {
  key: "minute",
  specifier: "m"
}, {
  key: "second",
  specifier: "s"
}, {
  key: "timeZoneName",
  specifier: "z"
}], br = {
  e: "c",
  E: "c",
  M: "L",
  Q: "q"
}, er = {}, O = {};
function nr(r) {
  return er[r] || (er[r] = new RegExp(r + "+")), er[r];
}
function W(r) {
  for (var e = [], n = r.charAt(0), a = n, t = 1; t < r.length; t++) {
    var i = r.charAt(t);
    i === a ? n += i : (e.push(n), n = a = i);
  }
  return e.push(n), e;
}
function ar(r, e) {
  var n = r.length, a = -Number.MAX_VALUE, t, i;
  for (var u in e) {
    for (var s = [], o = u.replace("v", "z"), l = 0, c = 0; c < n; c++) {
      var v = r[c], d = nr(v[0]), f = (d.exec(o) || [])[0];
      if (!f)
        l -= yn;
      else if (o = o.replace(f, m), f.length !== v.length) {
        var p = Math.max(Math.min(Nr[f.length] - Nr[v.length], 2), -2);
        l -= Q[p];
      }
      if (s.push(f), l < a)
        break;
    }
    o.length && (l -= W(o).length * gn), l > a && (a = l, t = s, i = e[u]);
  }
  i = i.replace("v", "z");
  for (var y = 0; y < n; y++) {
    var D = t[y];
    if (D && D !== r[y]) {
      var b = t[y][0];
      i = i.replace(nr(b), r[y]), br[b] && (i = i.replace(nr(br[b]), r[y]));
    }
  }
  return i;
}
function wn(r, e, n) {
  O[n] || (O[n] = {}), O[n][r] = e;
}
function bn(r, e) {
  var n = e.calendar.dateTimeFormats.availableFormats;
  if (n[r])
    return n[r];
  if (O[e.name] && O[e.name][r])
    return O[e.name][r];
  var a = r.search(Dn), t;
  if (a > 0) {
    var i = r.substr(0, a), u = r.substr(a);
    t = fr(
      e.calendar.dateTimeFormats.short,
      //should be deterimed based on specifiers
      n[u] || ar(W(u), n),
      n[i] || ar(W(i), n)
    );
  } else
    t = ar(W(r), n);
  return wn(r, t, e.name), t;
}
function Tn(r) {
  for (var e = [], n = 0; n < wr.length; n++) {
    var a = wr[n], t = a.key, i = r[t];
    if (i) {
      var u = a.specifier || a.getSpecifier(r);
      e.push(u.repeat(Sn[i]));
    }
  }
  return e.join(m);
}
function dr(r, e) {
  var n = e.calendar, a;
  if (q(r))
    n.patterns[r] ? a = n.patterns[r] : a = r;
  else if (r) {
    if (r.pattern)
      return r.pattern;
    var t = r.skeleton;
    t || (r.datetime ? a = fr(n.dateTimeFormats[r.datetime], n.timeFormats[r.datetime], n.dateFormats[r.datetime]) : r.date ? a = n.dateFormats[r.date] : r.time ? a = n.timeFormats[r.time] : t = Tn(r)), t && (a = bn(t, e));
  }
  return a || (a = n.patterns.d), a;
}
function Vr(r) {
  var e;
  return r <= 3 ? e = "abbreviated" : r === 4 ? e = "wide" : r === 5 ? e = "narrow" : r === 6 && (e = "short"), e;
}
function F(r, e, n, a, t) {
  return Gr(r, {
    type: e,
    nameType: Vr(n),
    standAlone: a,
    lower: t
  });
}
function Tr(r) {
  return typeof r == "function";
}
function yr(r) {
  return !!r && Tr(r.getTime) && Tr(r.getMonth);
}
var Fr = "month", X = "hour", Y = "zone", tr = "weekday", Cr = "quarter", Fn = {
  G: "era",
  y: "year",
  q: Cr,
  Q: Cr,
  M: Fr,
  L: Fr,
  d: "day",
  E: tr,
  c: tr,
  e: tr,
  h: X,
  H: X,
  k: X,
  K: X,
  m: "minute",
  s: "second",
  S: "millisecond",
  a: "dayperiod",
  x: Y,
  X: Y,
  z: Y,
  Z: Y
}, G = /d{1,2}|E{1,6}|e{1,6}|c{3,6}|c{1}|M{1,5}|L{1,5}|y{1,4}|H{1,2}|h{1,2}|k{1,2}|K{1,2}|m{1,2}|a{1,5}|s{1,2}|S{1,3}|z{1,4}|Z{1,5}|x{1,5}|X{1,5}|G{1,5}|q{1,5}|Q{1,5}|"[^"]*"|'[^']*'/g;
function Cn(r, e, n) {
  var a = zr(n), t;
  return r < a ? t = 7 - a + r : t = r - a, t + 1;
}
function $r(r, e, n, a) {
  return e <= 2 ? S(r + 1, e) : F(n, "months", e, a)[r];
}
function Kr(r, e, n, a) {
  var t = Math.floor(r.getMonth() / 3);
  return e < 3 ? t + 1 : F(n, "quarters", e, a)[t];
}
function $(r, e, n) {
  var a = n.shortHours, t = n.optionalMinutes, i = n.separator, u = n.localizedName, s = n.zZeroOffset, o = r.getTimezoneOffset() / 60;
  if (o === 0 && s)
    return "Z";
  var l = o <= 0 ? "+" : "-", c = Math.abs(o).toString().split("."), v = c[1] || 0, d = l + (a ? c[0] : S(c[0], 2));
  if ((v || !t) && (d += (i ? ":" : m) + S(v, 2)), u) {
    var f = o === 0 ? e.calendar.gmtZeroFormat : e.calendar.gmtFormat;
    d = fr(f, d);
  }
  return d;
}
function jr(r, e, n, a) {
  var t;
  return e < 3 ? t = Cn(r.getDay(), e, n) : t = F(n, "days", e, a)[r.getDay()], t;
}
var g = {};
g.d = function(r, e) {
  return S(r.getDate(), e);
};
g.E = function(r, e, n) {
  return F(n, "days", e)[r.getDay()];
};
g.M = function(r, e, n) {
  return $r(r.getMonth(), e, n, !1);
};
g.L = function(r, e, n) {
  return $r(r.getMonth(), e, n, !0);
};
g.y = function(r, e) {
  var n = r.getFullYear();
  return e === 2 && (n = n % 100), S(n, e);
};
g.h = function(r, e) {
  var n = r.getHours() % 12 || 12;
  return S(n, e);
};
g.H = function(r, e) {
  return S(r.getHours(), e);
};
g.k = function(r, e) {
  return S(r.getHours() || 24, e);
};
g.K = function(r, e) {
  return S(r.getHours() % 12, e);
};
g.m = function(r, e) {
  return S(r.getMinutes(), e);
};
g.s = function(r, e) {
  return S(r.getSeconds(), e);
};
g.S = function(r, e) {
  var n = r.getMilliseconds(), a;
  return n !== 0 ? a = S(String(n / 1e3).split(".")[1].substr(0, e), e, !0) : a = S(m, e), a;
};
g.a = function(r, e, n) {
  return F(n, "dayPeriods", e)[r.getHours() < 12 ? "am" : "pm"];
};
g.z = function(r, e, n) {
  return $(r, n, {
    shortHours: e < 4,
    optionalMinutes: e < 4,
    separator: !0,
    localizedName: !0
  });
};
g.Z = function(r, e, n) {
  return $(r, n, {
    separator: e > 3,
    localizedName: e === 4,
    zZeroOffset: e === 5
  });
};
g.x = function(r, e, n) {
  return $(r, n, {
    optionalMinutes: e === 1,
    separator: e === 3 || e === 5
  });
};
g.X = function(r, e, n) {
  return $(r, n, {
    optionalMinutes: e === 1,
    separator: e === 3 || e === 5,
    zZeroOffset: !0
  });
};
g.G = function(r, e, n) {
  var a = r.getFullYear() >= 0 ? 1 : 0;
  return F(n, "eras", e)[a];
};
g.e = jr;
g.c = function(r, e, n) {
  return jr(r, e, n, !0);
};
g.q = function(r, e, n) {
  return Kr(r, e, n, !0);
};
g.Q = Kr;
function re(r, e, n) {
  if (n === void 0 && (n = k), !yr(r))
    return r ?? m;
  var a = R(n), t = dr(e, a);
  return t.replace(G, function(i) {
    var u = i.length, s;
    return i.includes("'") || i.includes('"') ? s = i.slice(1, u - 1) : s = g[i[0]](r, u, a), s;
  });
}
function Ar(r, e, n) {
  var a = r.getTimezoneOffset(), t = new Date(r.getTime() + (e - n) * 6e4), i = t.getTimezoneOffset();
  return new Date(t.getTime() + (i - a) * 6e4);
}
function An(r, e) {
  !e && r.getHours() === 23 && r.setHours(r.getHours() + 2);
}
var Hn = /([+|-]\d{1,2})(:?)(\d{2})?/, In = /^\/Date\((.*?)\)\/$/, Ln = /[+-]\d*/, Rn = {
  2: /^\d{1,2}/,
  3: /^\d{1,3}/,
  4: /^\d{4}/
}, xn = /\d+/, Hr = "{0}", On = /^ */, _n = / *$/, Pn = [
  "yyyy/MM/dd HH:mm:ss",
  "yyyy/MM/dd HH:mm",
  "yyyy/MM/dd",
  "E MMM dd yyyy HH:mm:ss",
  "yyyy-MM-ddTHH:mm:ss.SSSSSSSXXX",
  "yyyy-MM-ddTHH:mm:ss.SSSXXX",
  "yyyy-MM-ddTHH:mm:ss.SSXXX",
  "yyyy-MM-ddTHH:mm:ssXXX",
  "yyyy-MM-ddTHH:mm:ss.SSSSSSS",
  "yyyy-MM-ddTHH:mm:ss.SSS",
  "yyyy-MM-ddTHH:mmXXX",
  "yyyy-MM-ddTHH:mmX",
  "yyyy-MM-ddTHH:mm:ss",
  "yyyy-MM-ddTHH:mm",
  "yyyy-MM-dd HH:mm:ss",
  "yyyy-MM-dd HH:mm",
  "yyyy-MM-dd",
  "HH:mm:ss",
  "HH:mm"
], Ir = ["G", "g", "F", "Y", "y", "M", "m", "D", "d", "y", "T", "t"], kn = 2029;
function w(r, e, n) {
  return !(r >= e && r <= n);
}
function M(r, e) {
  for (var n = e.format, a = e.idx, t = 0; n[a] === r; )
    t++, a++;
  return t > 0 && (a -= 1), e.idx = a, t;
}
function C(r, e) {
  var n = r ? Rn[r] || new RegExp("^\\d{1," + r + "}") : xn, a = e.value.substr(e.valueIdx, r).match(n);
  return a ? (a = a[0], e.valueIdx += a.length, parseInt(a, 10)) : null;
}
function x(r, e, n) {
  for (var a = 0, t = r.length, i, u, s = 0, o = 0, l; a < t; a++)
    i = r[a], u = i.length, l = e.value.substr(e.valueIdx, u), n && (l = l.toLowerCase()), l === i && u > s && (s = u, o = a);
  return s ? (e.valueIdx += s, o + 1) : null;
}
function ir(r) {
  var e = !1;
  return r.value.charAt(r.valueIdx) === r.format[r.idx] && (r.valueIdx++, e = !0), e;
}
function Gn(r) {
  var e = r.gmtFormat, n = r.gmtZeroFormat;
  if (!e)
    throw T.NoGMTInfo.error();
  return [e.replace(Hr, m).toLowerCase(), n.replace(Hr, m).toLowerCase()];
}
function K(r, e, n) {
  var a = n.shortHours, t = n.noSeparator, i = n.optionalMinutes, u = n.localizedName, s = n.zLiteral;
  if (r.UTC = !0, s && r.value.charAt(r.valueIdx) === "Z")
    return r.valueIdx++, !1;
  if (u && !x(Gn(e.calendar), r, !0))
    return !0;
  var o = Hn.exec(r.value.substr(r.valueIdx, 6));
  if (!o)
    return !u;
  var l = o[1], c = o[3], v = parseInt(l, 10), d = o[2], f = parseInt(c, 10);
  if (isNaN(v) || !a && l.length !== 3 || !i && isNaN(f) || t && d || (isNaN(f) && (f = null), w(v, -12, 13) || f && w(f, 0, 59)))
    return !0;
  r.valueIdx += o[0].length, r.hoursOffset = v, r.minutesOffset = f;
}
function ee(r, e, n) {
  var a = M(r, e), t = F(n, "months", a, r === "L", !0), i = a < 3 ? C(2, e) : x(t, e, !0);
  if (i === null || w(i, 1, 12))
    return !0;
  e.month = i - 1;
}
function ne(r, e, n) {
  var a = M(r, e), t = F(n, "days", a, r === "c", !0), i = a < 3 ? C(1, e) : x(t, e, !0);
  if (!i && i !== 0 || w(i, 1, 7))
    return !0;
}
var h = {};
h.d = function(r) {
  M("d", r);
  var e = C(2, r);
  if (e === null || w(e, 1, 31))
    return !0;
  r.day === null && (r.day = e);
};
h.E = function(r, e) {
  var n = M("E", r), a = x(F(e, "days", n, !1, !0), r, !0);
  if (a === null)
    return !0;
};
h.M = function(r, e) {
  return ee("M", r, e);
};
h.L = function(r, e) {
  return ee("L", r, e);
};
h.y = function(r) {
  var e = M("y", r), n = C(e === 1 ? void 0 : e, r);
  if (n === null)
    return !0;
  if (e === 2) {
    var a = (/* @__PURE__ */ new Date()).getFullYear();
    n = a - a % 100 + n, n > kn && (n -= 100);
  }
  r.year = n;
};
h.h = function(r) {
  M("h", r);
  var e = C(2, r);
  if (e === 12 && (e = 0), e === null || w(e, 0, 11))
    return !0;
  r.hours = e;
};
h.K = function(r) {
  M("K", r);
  var e = C(2, r);
  if (e === null || w(e, 0, 11))
    return !0;
  r.hours = e;
};
h.a = function(r, e) {
  var n = M("a", r), a = F(e, "dayPeriods", n, !1, !0), t = x([a.pm], r, !0);
  if (!t && !x([a.am], r, !0))
    return !0;
  r.pmHour = t;
};
h.H = function(r) {
  M("H", r);
  var e = C(2, r);
  if (e === null || w(e, 0, 23))
    return !0;
  r.hours = e;
};
h.k = function(r) {
  M("k", r);
  var e = C(2, r);
  if (e === null || w(e, 1, 24))
    return !0;
  r.hours = e === 24 ? 0 : e;
};
h.m = function(r) {
  M("m", r);
  var e = C(2, r);
  if (e === null || w(e, 0, 59))
    return !0;
  r.minutes = e;
};
h.s = function(r) {
  M("s", r);
  var e = C(2, r);
  if (e === null || w(e, 0, 59))
    return !0;
  r.seconds = e;
};
h.S = function(r) {
  var e = M("S", r), n = r.value.substr(r.valueIdx, e), a = null;
  if (isNaN(parseInt(n, 10)) || (a = parseFloat("0." + n, 10), a = U(a, 3), a *= 1e3, r.valueIdx += e), a === null || w(a, 0, 999))
    return !0;
  r.milliseconds = a;
};
h.z = function(r, e) {
  var n = M("z", r), a = n < 4, t = K(r, e, {
    shortHours: a,
    optionalMinutes: a,
    localizedName: !0
  });
  if (t)
    return t;
};
h.Z = function(r, e) {
  var n = M("Z", r), a = K(r, e, {
    noSeparator: n < 4,
    zLiteral: n === 5,
    localizedName: n === 4
  });
  if (a)
    return a;
};
h.x = function(r, e) {
  var n = M("x", r), a = K(r, e, {
    noSeparator: n !== 3 && n !== 5,
    optionalMinutes: n === 1
  });
  if (a)
    return a;
};
h.X = function(r, e) {
  var n = M("X", r), a = K(r, e, {
    noSeparator: n !== 3 && n !== 5,
    optionalMinutes: n === 1,
    zLiteral: !0
  });
  if (a)
    return a;
};
h.G = function(r, e) {
  var n = M("G", r), a = F(e, "eras", n, !1, !0), t = x([a[0], a[1]], r, !0);
  if (t === null)
    return !0;
};
h.e = function(r, e) {
  return ne("e", r, e);
};
h.c = function(r, e) {
  return ne("c", r, e);
};
function Un(r) {
  var e = r.year, n = r.month, a = r.day, t = r.hours, i = r.minutes, u = r.seconds, s = r.milliseconds, o = r.pmHour, l = r.UTC, c = r.hoursOffset, v = r.minutesOffset, d = t !== null || i !== null || u || null, f = /* @__PURE__ */ new Date(), p;
  return e === null && n === null && a === null && d ? (e = f.getFullYear(), n = f.getMonth(), a = f.getDate()) : (e === null && (e = f.getFullYear()), a === null && (a = 1)), o && t < 12 && (t += 12), l ? (c && (t += -c), v && (i += -v * (c < 0 ? -1 : 1)), p = new Date(Date.UTC(e, n, a, t, i, u, s))) : (p = new Date(e, n, a, t, i, u, s), An(p, t)), e < 100 && p.setFullYear(e), p.getDate() !== a && l === void 0 ? null : p;
}
function zn(r, e) {
  var n = On.exec(e)[0], a = _n.exec(e)[0];
  return "" + n + r + a;
}
function Zn(r, e, n) {
  for (var a = dr(e, n).split(m), t = {
    format: a,
    idx: 0,
    value: zn(r, e),
    valueIdx: 0,
    year: null,
    month: null,
    day: null,
    hours: null,
    minutes: null,
    seconds: null,
    milliseconds: null
  }, i = a.length, u = !1; t.idx < i; t.idx++) {
    var s = a[t.idx];
    if (u)
      s === "'" && (u = !1), ir(t);
    else if (h[s]) {
      var o = h[s](t, n);
      if (o)
        return null;
    } else if (s === "'")
      u = !0, ir(t);
    else if (!ir(t))
      return null;
  }
  return t.valueIdx < r.length ? null : Un(t) || null;
}
function Bn(r) {
  var e = r.substr(0, 1) === "-" ? -1 : 1, n = r.substring(1);
  return n = parseInt(n.substr(0, 2), 10) * 60 + parseInt(n.substring(2), 10), e * n;
}
function Qn(r) {
  if (r && r.indexOf("/D") === 0) {
    var e = In.exec(r);
    if (e) {
      e = e[1];
      var n = Ln.exec(e.substring(1));
      return e = new Date(parseInt(e, 10)), n && (n = Bn(n[0]), e = Ar(e, e.getTimezoneOffset(), 0), e = Ar(e, 0, -1 * n)), e;
    }
  }
}
function Xn(r) {
  for (var e = [], n = r.patterns, a = Ir.length, t = 0; t < a; t++)
    e.push(n[Ir[t]]);
  return e.concat(Pn);
}
function Yn(r, e, n) {
  if (n === void 0 && (n = k), !r)
    return null;
  if (yr(r))
    return r;
  var a = String(r).trim(), t = Qn(a);
  if (t)
    return t;
  var i = R(n), u = e || Xn(i.calendar);
  u = Array.isArray(u) ? u : [u];
  for (var s = u.length, o = 0; o < s; o++)
    if (t = Zn(a, u[o], i), t)
      return t;
  return t;
}
var Wn = {
  month: {
    type: "months",
    minLength: 3,
    standAlone: "L"
  },
  quarter: {
    type: "quarters",
    minLength: 3,
    standAlone: "q"
  },
  weekday: {
    type: "days",
    minLength: {
      E: 0,
      c: 3,
      e: 3
    },
    standAlone: "c"
  },
  dayperiod: {
    type: "dayPeriods",
    minLength: 0
  },
  era: {
    type: "eras",
    minLength: 0
  }
}, Lr = "literal";
function ur(r, e) {
  var n = r[r.length - 1];
  n && n.type === Lr ? n.pattern += e : r.push({
    type: Lr,
    pattern: e
  });
}
function qn(r) {
  return r === "h" || r === "K";
}
function Jn(r, e) {
  e === void 0 && (e = k);
  for (var n = R(e), a = dr(r, n), t = [], i = G.lastIndex = 0, u = G.exec(a); u; ) {
    var s = u[0];
    if (i < u.index && ur(t, a.substring(i, u.index)), s.startsWith('"') || s.startsWith("'"))
      ur(t, s);
    else {
      var o = s[0], l = Fn[o], c = {
        type: l,
        pattern: s
      };
      l === "hour" && (c.hour12 = qn(s));
      var v = Wn[l];
      if (v) {
        var d = mr(v.minLength) ? v.minLength : v.minLength[o], f = s.length;
        f >= d && (c.names = {
          type: v.type,
          nameType: Vr(f),
          standAlone: v.standAlone === o
        });
      }
      t.push(c);
    }
    i = G.lastIndex, u = G.exec(a);
  }
  return i < a.length && ur(t, a.substring(i)), t;
}
var Vn = /\{(\d+)(:[^}]+)?\}/g;
function ae(r, e, n) {
  if (e) {
    if (yr(r))
      return re(r, e, n);
    if (mr(r))
      return Jr(r, e, n);
  }
  return r ?? m;
}
function Rr(r, e, n) {
  return r.replace(Vn, function(a, t, i) {
    var u = e[parseInt(t, 10)];
    return ae(u, i ? i.substring(1) : m, n);
  });
}
const $n = {
  name: "@progress/kendo-react-intl",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1702644631,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/components/my-license/"
};
class gr {
  /**
   * Creates a new instance of the internationalization service.
   *
   * @param locale - The locale that will be used by the internationalization methods.
   */
  constructor(e) {
    if (this.locale = e, ie($n), e === "" && process.env.NODE_ENV !== "production")
      throw "Locale should not be empty string";
  }
  /**
   * Formats a string with placeholders such as `Total amount {0:c}`.
   *
   * @param format - The format string.
   * @param values - One or more values to output in the format string placeholders.
   * @return - The formatted string.
   */
  format(e, ...n) {
    return n.length === 1 && Array.isArray(n[0]) ? Rr(e, n[0], this.locale) : Rr(e, n, this.locale);
  }
  /**
   * Converts a `Date` object to a string based on the specified format. If no format is provided, the default short date format is used.
   *
   * @param value - The date which will be formatted.
   * @param format - The format string or options.
   * @return - The formatted date.
   */
  formatDate(e, n) {
    return re(e, n, this.locale);
  }
  /**
   * Converts an object to a string based on the specified format.
   *
   * @param value - The value which will be formatted.
   * @param format - The format to use.
   * @return - The formatted object.
   */
  toString(e, n) {
    return ae(e, n, this.locale);
  }
  /**
   * Converts a string to a `Number`.
   *
   * @param value - The string which will be parsed.
   * @param format - The format string or options.
   * @return - The parsed number.
   */
  parseNumber(e, n) {
    return fn(e, this.locale, n);
  }
  /**
   * Converts a string to a `Date` object based on the specified format.
   *
   * @param value - The string which will be converted.
   * @param format - The format strings or options.
   * @return - The parsed date.
   */
  parseDate(e, n) {
    return Yn(e, n, this.locale);
  }
  /**
   * Converts a `Number` to a string based on the specified format.
   *
   * @param value - The number which will be formatted.
   * @param format - The format string or options.
   * @return - The formatted number.
   */
  formatNumber(e, n) {
    return Jr(e, n, this.locale);
  }
  /**
   * Returns a localized date field name based on specific `dateFieldName` options.
   *
   * @param options - The detailed configuration for the desired date field name.
   * @returns - The localized date field name from the current locale based on the option.
   */
  dateFieldName(e) {
    return ge(e, this.locale);
  }
  /**
   * Returns the day names from the current locale based on the option.
   *
   * @param options - The detailed configuration for the desired date format.
   * @return - The day names from the current locale based on the option.
   */
  dateFormatNames(e) {
    return Gr(this.locale, e);
  }
  /**
   * Splits the date format into objects which contain information about each part of the pattern.
   *
   * @param format - The format string or options.
   * @returns - The date format parts.
   */
  splitDateFormat(e) {
    return Jn(e, this.locale);
  }
  /**
   * Returns the number symbols from the current locale.
   *
   * @return - The number symbols from the current locale.
   */
  numberSymbols() {
    return _e(this.locale);
  }
  /**
   * Returns the first day index, starting from Sunday.
   *
   * @return - The index of the first day of the week (0 == Sunday).
   */
  firstDay() {
    return zr(this.locale);
  }
  /**
   * @hidden
   */
  localeInfo() {
    return R(this.locale);
  }
  /**
   * @hidden
   */
  localeCurrency() {
    return vr(this.locale);
  }
}
const or = /* @__PURE__ */ Object.create({});
class hr {
  constructor(e) {
    if (this.language = e, e === "" && process.env.NODE_ENV !== "production")
      throw "Language should not be an empty string";
  }
  /* eslint-disable max-len */
  /**
   * Provides a string based on a key for the current language. When no string for the current language is available under this key, the `defaultValue` is returned.
   *
   * @param key - The key which identifies the string for the current language.
   * @param defaultValue - The default value which will be returned when no string
   * for the current language is available under the key.
   * @return - The string for the current language.
   */
  // tslint:enable:max-line-length
  toLanguageString(e, n) {
    return this.language && or[this.language] && or[this.language].hasOwnProperty(e) ? or[this.language][e] : n;
  }
}
const L = A.createContext({
  intl: new gr("en"),
  localization: new hr()
});
class Kn extends A.Component {
  /**
   * Returns an internationalization service. The method is suitable for overriding when you implement custom internationalization behavior.
   */
  getIntlService() {
    return new gr(this.props.locale);
  }
  /**
   * @hidden
   */
  render() {
    return /* @__PURE__ */ A.createElement(L.Consumer, null, (e) => /* @__PURE__ */ A.createElement(L.Provider, { value: { ...e, intl: this.getIntlService() } }, this.props.children));
  }
}
Kn.propTypes = {
  locale: xr.string
};
class jn extends A.Component {
  /**
   * Returns a localization service. The method is suitable for overriding when you implement custom localization behavior.
   */
  getLocalizationService() {
    return new hr(this.props.language);
  }
  /**
   * @hidden
   */
  render() {
    return /* @__PURE__ */ A.createElement(L.Consumer, null, (e) => /* @__PURE__ */ A.createElement(L.Provider, { value: { ...e, localization: this.getLocalizationService() } }, this.props.children));
  }
}
jn.propTypes = {
  language: xr.string
};
function na(r) {
  if (!r && process.env.NODE_ENV !== "production")
    throw `Passed component - ${r} is invalid.`;
  const e = r.context;
  return e && e.intl ? e.intl : new gr("en");
}
function aa(r) {
  if (!r && process.env.NODE_ENV !== "production")
    throw `Passed component - ${r} is invalid.`;
  const e = r.context;
  return e && e.localization ? e.localization : new hr();
}
function ta(r) {
  r.contextType = L;
}
function ia(r) {
  r.contextType = L;
}
const ua = () => A.useContext(L).intl, oa = () => A.useContext(L).localization;
export {
  ua as C,
  na as D,
  oa as S,
  gr as c,
  aa as w,
  ia as x,
  ta as z
};
